<template>
  <div class="site-shell">
    <nav class="nav-wrap scrolled">
      <div class="nav container-wide">
        <router-link class="brand" to="/" aria-label="WinCard home"><img src="@/assets/logo.svg" alt="WinCard" /></router-link>
        <div class="nav-links" :class="{ open: menuOpen }">
          <div class="nav-links-actions"><a class="login" :href="loginUrl">Log in</a><a class="button button-small" href="/#early-access" @click="menuOpen = false">Join early access <span>→</span></a></div>
          <a href="/#features" @click="menuOpen = false">Features</a>
          <a href="/#how-it-works" @click="menuOpen = false">How it works</a>
          <a href="/#early-access" @click="menuOpen = false">Early access</a>
          <a href="/#pricing" @click="menuOpen = false">Pricing</a>
        </div>
        <div class="nav-actions"><a class="login" :href="loginUrl">Log in</a><a class="button button-small" href="/#early-access">Join early access <span>→</span></a></div>
        <button class="menu-button" @click="menuOpen = !menuOpen" :aria-expanded="menuOpen" aria-label="Toggle navigation"><span></span><span></span></button>
      </div>
    </nav>

    <main class="resource-page container-narrow">
      <slot></slot>
    </main>

    <footer class="footer">
      <div class="container-wide footer-grid">
        <div><router-link class="brand" to="/"><img src="@/assets/logo.svg" alt="WinCard" /></router-link><p>Better customer relationships,<br>one return visit at a time.</p><small>© 2026 WinCard, Inc.</small></div>
        <div><b>PRODUCT</b><a href="/#features">Features</a><a href="/#pricing">Pricing</a><a href="/#how-it-works">Integrations</a></div>
        <div><b>RESOURCES</b><router-link to="/help-center">Help center</router-link><router-link to="/guides">Guides</router-link><router-link to="/retention-guides">Retention guides</router-link><router-link to="/contact">Contact</router-link></div>
        
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MarketingLayout',
  data() { return { menuOpen: false } },
  computed: {
    loginUrl() { return process.env.VUE_APP_BASE_URL },
  },
}
</script>

<style scoped>
.resource-page { padding-top: 159px; padding-bottom: 110px; min-height: 60vh; }
@media (max-width: 650px) { .resource-page { padding-top: 106px; } }
</style>
